import Vue from 'vue'

export const EventsBus = new Vue()

export const EventBusClickonChains = new Vue({
  methods: {
    clickonChains () {
      this.$emit('selectFirstChain')
    }
  }
})
